import { useCallback, useRef, useState } from 'react'

export const useTimeoutWorker = () => {
  const [isRunning, setIsRunning] = useState(false)

  const _createWorkerScript = (timeoutMs: number) => `
  setTimeout(() => {
    postMessage('timeout')
  }, ${timeoutMs})
  `
  const worker = useRef<Worker | null>(null)
  const urlRef = useRef<string | null>(null)

  const startTimeout = useCallback(
    (callback: () => void, timeoutMs: number) => {
      if (typeof Worker !== 'undefined') {
        if (!worker.current) {
          if (urlRef.current) {
            URL.revokeObjectURL(urlRef.current)
            urlRef.current = null
          }
          const blob = new Blob([_createWorkerScript(timeoutMs)], { type: 'application/javascript' })
          const url = URL.createObjectURL(blob)
          urlRef.current = url
          worker.current = new Worker(url)

          setIsRunning(true)
          worker.current.onmessage = (event) => {
            if (event.data === 'timeout') {
              callback()
            }
          }
        }
      } else {
        throw new Error('Web Workers are not supported')
      }
    },
    [worker],
  )

  return {
    startTimeout,
    stopTimeout: () => {
      if (worker.current) {
        worker.current.terminate()
        worker.current = null
        setIsRunning(false)
      }
      if (urlRef.current) {
        URL.revokeObjectURL(urlRef.current)
        urlRef.current = null
      }
    },
    isRunning,
  }
}
